import { HelpItem } from '@app/api/public/HelpApi';
import { ResponderProvided, DropResult } from 'react-beautiful-dnd';
import { trpc } from '../../../lib/trpc';

type UseDragVariables = { result: DropResult; provided: ResponderProvided };

export const sortList = (result: DropResult, listItems: HelpItem[]) => {
    if (!result || !result.destination) return;
    const items = [...listItems];
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    return {
        items,
        reorderedItem,
        index: result.destination.index,
    };
};

const dragEnd = ({ result }: UseDragVariables, listItems?: HelpItem[]) => {
    if (!listItems) return;
    const sortedList = sortList(result, listItems);
    if (!sortedList) return;
    return sortedList.items.map((item, index) => {
        return { id: item.id, sort: index };
    });
};

const useDragEnd = (application: HelpItem['application']) => {
    const utils = trpc.useContext();

    const helpItemsQuery = trpc.HelpApi.listByApplication.useQuery(application);

    const { mutate } = trpc.HelpApi.updateSortOrder.useMutation({
        onMutate: (variables) => {
            utils.HelpApi.listByApplication.cancel(application);
            const helpItems = utils.HelpApi.listByApplication.getData(application);

            if (!helpItems) return;
            helpItems?.forEach((item) => {
                const newSortItem = variables.find((variable) => variable.id === item.id);
                if (newSortItem) {
                    item.sort = newSortItem.sort;
                }
            });

            helpItems.sort((a, b) => a.sort - b.sort);
            utils.HelpApi.listByApplication.setData(application, helpItems);
        },
        onSettled: () => {
            utils.HelpApi.listByApplication.invalidate(application);
        },
    });

    return async (variables: UseDragVariables) => {
        if (!helpItemsQuery.data) return;
        const items = dragEnd(variables, helpItemsQuery.data);
        if (!items) return;
        mutate(items);
    };
};

export default useDragEnd;
